import {
  getWhiteLabelLookupHost,
  isDefaultPlatformHost,
  readBrandCache,
} from "./whiteLabelBrandCache";

const PLATFORM_CHECKOUT_NAME = "BluTec Ping";

export function checkoutBrandFrom(brand) {
  const isWhiteLabel = Boolean(brand?.isWhiteLabel || brand?.id);
  if (isWhiteLabel) {
    return {
      name: String(brand.company_name || brand.name || "").trim(),
      image: String(brand.logo_url || brand.favicon_url || "").trim(),
      isWhiteLabel: true,
    };
  }
  return {
    name: PLATFORM_CHECKOUT_NAME,
    image: String(brand?.logo_url || brand?.favicon_url || "").trim(),
    isWhiteLabel: false,
  };
}

export function getBrandCheckoutName(brand) {
  return checkoutBrandFrom(brand).name || (brand?.id ? "" : PLATFORM_CHECKOUT_NAME);
}

/** Live brand first, then white-label session cache. Never invent Blutec on a partner host. */
export function resolveCheckoutBrand(brand) {
  if (brand?.id || brand?.isWhiteLabel) {
    return checkoutBrandFrom(brand);
  }
  try {
    const host = getWhiteLabelLookupHost();
    const cached = readBrandCache(host);
    if (cached?.id) return checkoutBrandFrom({ ...cached, isWhiteLabel: true });
    if (isDefaultPlatformHost(host)) {
      return { name: PLATFORM_CHECKOUT_NAME, image: "", isWhiteLabel: false };
    }
    return { name: "", image: "", isWhiteLabel: true };
  } catch (_) {
    return { name: PLATFORM_CHECKOUT_NAME, image: "", isWhiteLabel: false };
  }
}
